import React, { useEffect, useState } from "react";
import { contentful } from "../utils/contentful";
import styled from "styled-components";
import RichText from "../components/contentfulMapper/rich-text";
import { tablet } from "../responsive";
import SpinningWheel from "../components/SpinningWheel";
const StyledHelp = styled.div`
  padding: 2rem 12rem;
  ${tablet({ padding: "2rem 2rem" })}

  h1 {
    margin-bottom: 1rem;
  }
`;
function Help() {
  const [resources, setResources] = useState("");
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    contentful().then(({ data, errors }) => {
      if (errors) {
        console.error(errors);
      }

      const formatted = RichText(
        data.learningResourcesCollection.items[0].learningResources.json
      );
      setLoading(false);
      setResources(formatted);
    });
  }, []);

  return loading ? (
    <SpinningWheel />
  ) : (
    <StyledHelp>
      <h1>About AND Insightfull</h1>
      {resources}
    </StyledHelp>
  );
}

export default Help;
